import { useState  } from "react";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Form, Alert } from "react-bootstrap";
import { Watch } from "react-loader-spinner";
import axios from "axios";


const ChangePassword = () => {
  const [old_password, oldPassword] = useState("");
  const [new_password, newPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirm_password, confirmPassword] = useState("");
  const [error, setError] = useState([]);

  const onUpdatePassword = (e) => {
    e.preventDefault();
    if (isInvalid(old_password)) {
      toast.error("Old Password Is Required");
      return false;
    }
    if (isInvalid(new_password)) {
      toast.error("New Password Is Required");
      return false;
    }
    if (new_password !== confirm_password) {
      toast.error("Password does not match");
      return false;
    }
    setError([]);
    setLoading(true);
    axios
      .post(API_URL.SETTING_PASSWORD, {
        old_password: old_password,
        password: new_password,
        password_confirmation: confirm_password,
      })
      .then(
        (response) => {
          setLoading(false);
          if (response.data.status === 1) {
            toast.success("Password Updated Successfully", { autoClose: 3000 });
          } else {
            if (response.data.data) {
              toast.error(response.data.data, { autoClose: 3000 });
            }
          }
        },
        (error) => {
          setLoading(false);
          toast.error("Something went wrong..", { autoClose: 3000 });
        }
      );
  };
  const isInvalid = (value) => {
    return !value || value === "" || value === null;
  };


  return (
    <div className="row">
      <div className="col-md-6 mt-3">
        <div className="card">
          <div className="card-body">
            <form onSubmit={onUpdatePassword}>
              <h4 className="card-title">Change Password</h4>
              {error.length > 0 && (
                <>
                  {["danger"].map((variant) => (
                    <Alert key={variant} variant={variant}>
                      {error.map((element, key) => {
                        return <div key={key}>{element}</div>;
                      })}
                    </Alert>
                  ))}
                </>
              )}
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Old Password</label>
                    <Form.Control
                      type="password"
                      value={old_password}
                      placeholder="Old Password"
                      onChange={(e) => oldPassword(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label>New Password</label>
                    <Form.Control
                      type="password"
                      value={new_password}
                      placeholder="New Password"
                      onChange={(e) => newPassword(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Confirm Password</label>
                    <Form.Control
                      type="password"
                      value={confirm_password}
                      placeholder="Confirm Password"
                      onChange={(e) => confirmPassword(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-12 text-right">
                  <div className="text-end">
                    <button type="submit" className="btn btn-primary">
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Update"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
